import React from "react";
import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import { ArrowUpRight, CaretRight } from "@phosphor-icons/react";

interface HeaderItemProps {
  icon: React.ElementType;
  text: string;
  onClick: () => void;
  isExternalLink?: boolean;
}

const menuItemStyles = {
  px: "24px",
  color: "#333",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
};

export const HeaderItem: React.FC<HeaderItemProps> = ({
  icon: Icon,
  text,
  onClick,
  isExternalLink = false
}) => {
  return (
    <MenuItem onClick={onClick} sx={menuItemStyles}>
      <ListItemIcon sx={{ minWidth: "28px" }}>
        {React.createElement(Icon, { size: 20, color: "#798397", weight: "duotone" })}
      </ListItemIcon>
      <ListItemText primary={text} />
      {isExternalLink ? (
        <Box>
          <ArrowUpRight size={16} color="#31333A" />
        </Box>
      ) : (
        <CaretRight size={16} color="#31333A" />
      )}
    </MenuItem>
  );
};
